import React, { useEffect, useState } from "react";
import { Edit } from "react-feather";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { handleErrors } from "../../services/handleErrors";
import { fetchSubclient } from "../../services/subclientesServices";
import SubclientInfo from "./SubclientInfo";
import ModalTabs from "./Tabs";

const ModalSubclients = ({ toggle, subclientId, razonSocial, ClientId, subclienteUtil }) => {
  const [editionModal, setEditionModal] = useState(false);
  const [subclientData, setSubclientData] = useState(null);
  useEffect(async () => {
    try {
      const data = await fetchSubclient(subclientId);
      setSubclientData(data);
    } catch (error) {
      handleErrors(error);
    }
  }, []);
  const closeWinows = () => {
    setEditionModal(!editionModal);
    toggle();
  };
  return (
    <>
      <Modal centered isOpen toggle={toggle}>
        <ModalHeader toggle={toggle}>
          Detalle Subcliente
          <Button size="xs" id="btnModifyingAsignado" color="link" onClick={() => setEditionModal(!editionModal)}>
            <Edit size="24" />
          </Button>
        </ModalHeader>
        <ModalBody>
          <ModalTabs subclientId={subclientId} />
        </ModalBody>
      </Modal>
      {editionModal ? (
        <SubclientInfo toggle={closeWinows} subclientData={subclientData} razonSocial={razonSocial} ClientId={ClientId} subclienteUtil={subclienteUtil} />
      ) : null}
    </>
  );
};

export default ModalSubclients;
